

import {
  FETCH_LEAVES_REQUEST,
  FETCH_LEAVES_SUCCESS,
  FETCH_LEAVES_FAILURE,
  UPDATE_LEAVE_STATUS_REQUEST,
  UPDATE_LEAVE_STATUS_SUCCESS,
  UPDATE_LEAVE_STATUS_FAILURE,
  FETCH_USER_LEAVES_REQUEST,
  FETCH_USER_LEAVES_SUCCESS,
  FETCH_USER_LEAVES_FAILURE,
} from "../actions/leaveActions";

const initialState = {
  leaves: [],

  // ✅ NEW STATE
  usersRemainingLeaves: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
  },

  loading: false,
  error: null,
};

const leaveReducer = (state = initialState, action) => {
  switch (action.type) {

    case FETCH_LEAVES_REQUEST:
    case UPDATE_LEAVE_STATUS_REQUEST:
    case FETCH_USER_LEAVES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_LEAVES_SUCCESS:
      return { ...state, loading: false, leaves: action.payload };

    case FETCH_USER_LEAVES_SUCCESS:
      return {
        ...state,
        loading: false,
        usersRemainingLeaves: action.payload.users,
        pagination: action.payload.pagination,
      };

    case UPDATE_LEAVE_STATUS_SUCCESS:
      return { ...state, loading: false };

    case FETCH_LEAVES_FAILURE:
    case UPDATE_LEAVE_STATUS_FAILURE:
    case FETCH_USER_LEAVES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default leaveReducer;
